import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { PromoCodeService } from "../../../../../services/promocode.service";
import { ToastrService } from 'ngx-toastr';


import { AccountSettingsService } from '../../../../../app/main/pages/account-settings/account-settings.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { log } from 'console';

@Component({
  selector: 'app-coupon-sidebar',
  templateUrl: './coupon-sidebar.component.html'
})
export class CouponSidebarComponent implements OnInit {

  @Input() currentCoupon;
  @Input() plans;

  @Output() newItemEvent = new EventEmitter<string>();

  public data: any;
  public loadingButton = false;
  public alertClose = true;
  public alert = "Error!";
  public today = new Date().toISOString().slice(0, 10);


  public myUser = JSON.parse(localStorage.getItem('currentCoupon'));


  // private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreSidebarService} _coreSidebarService
   */
  constructor(
    private _coreSidebarService: CoreSidebarService, 
    private _httpClient: HttpClient,
    private PromoCodeService: PromoCodeService,
    private _toastrService: ToastrService,
    private _accountSettingsService: AccountSettingsService) {
    this._unsubscribeAll = new Subject();
  }

  /**
   * Toggle the sidebar
   *
   * @param name
   */
  toggleSidebar(name): void {        
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
    this.addNewItem(this.currentCoupon);
    this.alertClose = true;
    this.currentCoupon = {
      "name": "",
      "code": "",
      "startDate": this.today,
      "endDate": null,
      "status": null,
      "plan_id": [],
      "settings": {
          "setup_amount": 0,
          "setup_percentage": 0,
          "membership_amount": 0,
          "membership_percentage": 0
      },
      "report": {
          "visualization_counter": 0,
          "activation_counter": 0
      }
  };
  }

  /**
   * Submit
   *
   * @param form
   */
  submit(form, type) {

    if (form.valid) {      
      this.loadingButton = true; 
      this.alertClose = true;

      switch (type) {
        case 'new':

        Swal.fire({
          icon: "question",
          title: "Publish this coupon?",
          html: '<div><p>Once you publish this coupon, it can no longer be edited. Would you like to publish it now?</p></div>',
          allowOutsideClick: function () {
            return !Swal.isLoading();
          },
          showConfirmButton: true,
          confirmButtonText: 'Publish',
          showCancelButton: true,
          cancelButtonText: "Later"  
        }).then((result) => {

          if (result.value) {
            this.currentCoupon['status'] = 'active';
          };          

          this.PromoCodeService
          .addNewPromoCode(this.currentCoupon)
          .then(
            data => {

    
              this.loadingButton = false;
              this.toggleSidebar('coupon-sidebar'); 
    
            },
            error => {
              Swal.fire({
                title: "Error",
                text: "This Coupon are not eligible.",
                html:
                  '<div><p>'+ error +'<p/></div><div class="row">',
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.loadingButton = false;
            }
          );

        });
        
          break;

        case 'update':
          this.PromoCodeService
          .updatePromoCode(this.currentCoupon)
          .then(
            data => {
              // Change successful
              // Display confimation toast!
              this._toastrService.success(
                this.currentCoupon.name +' have successfully updated. 🎉',
                  'Success! Your coupon was updated.',
                { toastClass: 'toast ngx-toastr', closeButton: true }
              );
    
              this.loadingButton = false;
              this.toggleSidebar('coupon-sidebar'); 
    
            },
            error => {
              Swal.fire({
                title: "Error",
                text: "This Coupon are not eligible.",
                html:
                  '<div><p>'+ error +'<p/></div><div class="row">',
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.loadingButton = false;
            }
          );
          break;

      
        case 'publish':

          Swal.fire({
            icon: "question",
            title: "Publish this coupon?",
            html: '<div><p>Once you publish this coupon, it can no longer be edited. Would you like to publish it now?</p></div>',
            allowOutsideClick: function () {
              return !Swal.isLoading();
            },
            showConfirmButton: true,
            confirmButtonText: 'Publish',
            showCancelButton: true,
            cancelButtonText: "Later"  
          }).then((result) => {

            if (result.value) {

              this.currentCoupon.status = 'active';
              this.PromoCodeService
              .updatePromoCode(this.currentCoupon)
              .then(
                data => {
                  // Change successful
                  // Display confimation toast!
                  this._toastrService.success(
                    this.currentCoupon.name +' have successfully updated. 🎉',
                      'Success! Your coupon was updated.',
                    { toastClass: 'toast ngx-toastr', closeButton: true }
                  );
        
                  this.loadingButton = false;
                  this.toggleSidebar('coupon-sidebar'); 
        
                },
                error => {
                  Swal.fire({
                    title: "Error",
                    text: "This Coupon are not eligible.",
                    html:
                      '<div><p>'+ error +'<p/></div><div class="row">',
                    icon: "error",
                    customClass: {
                      confirmButton: "btn btn-success",
                    },
                  });
                  this.loadingButton = false;
                }
              );
    

            };
            this.loadingButton = false;

          });


      

          break;

        
        default:
          break;
      }



    }else{
      setTimeout(() => {
        this.loadingButton = false;
        this.alertClose = false;

      }, 1000);            
    }


  }

  changeStatus(){
    switch (this.currentCoupon.status) {
      case "active":
        this.currentCoupon.status = "inactive"
        break;
    
      default:
        this.currentCoupon.status = "active"
        break;
    }

  }

  addNewItem(value: any) {
    this.newItemEvent.emit(value);
  }

  selectAll() {
    this.currentCoupon.plan_id = this.plans.map(x => x.id);
  }  
  unselectAll() {
    this.currentCoupon.plan_id = [];
  }  

  ngOnInit(): void {
    this._accountSettingsService.onSettingsChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(response => {
      this.data = response;
    });  
  }
}
